var currentSelectedVariant = null;
let firstLoad = true;

function changeVariantDropdown(value, sectionId, forloop) {
    $("#Option-" + sectionId + "-" + forloop).val(value);
    $(".product-form__input--dropdown").addClass("dropdown-hide");
    checkVariants();
}

function checkVariants() {
    // console.log(productData)

    var option1 = null;
    var option2 = null;
    var option3 = null;

    $.each($(".select__select"), function (i, select) {
        i++;
        var foundActiveVariant = false;

        if (i === 1) {
            option1 = select.value;
            var listElementHTML = $(this)
                .closest(".product-form__input--dropdown")
                .find(".dropdown-overlay--item[value='" + option1 + "']")
                .html();
            $(this).closest(".product-form__input--dropdown").find(".form__label").html(listElementHTML);
        } else if (i === 2) {
            option2 = select.value;
            var listElement = $(this).closest(".product-form__input--dropdown").find(".dropdown-overlay").find("li");

            $.each(listElement, function (i, list) {
                $(list).css("display", "none");
                $.each(productData.variants, function (i, variant) {
                    if (variant.options[0] === option1 && variant.options[1] === $(list).data("title")) {
                        $(list).css("display", "flex");
                        if (option2 === $(list).data("title")) {
                            foundActiveVariant = true;
                        }
                    }
                });
            });

            if (foundActiveVariant === false) {
                $.each(listElement, function (i, list) {
                    if ($(list).css("display") === "flex") {
                        $(select).val($(list).data("title"));
                        option2 = $(list).data("title");
                        return;
                    }
                });
            }

            var listElementHTML = $(this)
                .closest(".product-form__input--dropdown")
                .find(".dropdown-overlay--item[value='" + option2 + "']")
                .html();
            $(this).closest(".product-form__input--dropdown").find(".form__label").html(listElementHTML);
        } else if (i === 3) {
            option3 = select.value;
            var listElement = $(this).closest(".product-form__input--dropdown").find(".dropdown-overlay").find("li");
            $.each(listElement, function (i, list) {
                $(list).css("display", "none");

                $.each(productData.variants, function (i, variant) {
                    if (variant.options[0] === option1 && variant.options[1] === option2 && variant.options[2] === $(list).data("title")) {
                        $(list).css("display", "flex");
                        if (option3 === $(list).data("title")) {
                            foundActiveVariant = true;
                        }
                    }
                });
            });

            if (foundActiveVariant === false) {
                $.each(listElement, function (i, list) {
                    if ($(list).css("display") === "flex") {
                        $(select).val($(list).data("title"));
                        option3 = $(list).data("title");
                        return;
                    }
                });
            }
        }
        checkHasDropdown($(this));

        // console.log($(this).closest(".product-form__input--dropdown").find(".form__label").text(select.value))

        var listElementHTML = $(this)
            .closest(".product-form__input--dropdown")
            .find(".dropdown-overlay--item[value='" + option3 + "']")
            .html();
        $(this).closest(".product-form__input--dropdown").find(".form__label").html(listElementHTML);
    });

    function checkHasDropdown(_this) {
        _this.closest(".product-form__input--dropdown").find(".form__label").removeClass("no-dropdown");
        let liElm = _this.closest(".product-form__input--dropdown").find(".dropdown-overlay li");
        let countShow = 0;
        $.each(liElm, function (i, li) {
            if (li.style.display == "flex") countShow++;
        });
        if (countShow == 1) _this.closest(".product-form__input--dropdown").find(".form__label").addClass("no-dropdown");
    }

    $.each($(".select__select"), function (i, select) {
        i++;
        if (i === 1) {
            option1 = $(this).val();
        } else if (i === 2) {
            option2 = $(this).val();
        } else if (i === 3) {
            option3 = $(this).val();
        }
    });

    var variantTitle = null;

    if (option3 !== null) {
        variantTitle = option1 + " / " + option2 + " / " + option3;
    } else if (option2 !== null) {
        variantTitle = option1 + " / " + option2;
    } else if (option1 !== null) {
        variantTitle = option1;
    }

    console.log(variantTitle);

    //IF SALE-20 TAG THEN DISCOUNT PRICE

    $(".product-form-new").addClass("not-available");
    $.each(productData.variants, function (i, variant) {
        if (variant.title === variantTitle) {
            currentSelectedVariant = variant.id;
            $("#AddToCartForm input[name='id']").val(variant.id);
            if (!firstLoad && window.history.replaceState) {
                const variantUrl = new URL(window.location.href);
                if (variantUrl.searchParams.get("variant") !== String(variant.id)) {
                    variantUrl.searchParams.set("variant", String(variant.id));
                    window.history.replaceState(window.history.state, "", variantUrl.href);
                }
            }
            if ((!firstLoad || new URL(window.location.href).searchParams.has("variant")) && variant.featured_image) {
                var gallery = $("#ProductPhoto");
                var selectVariantImage = function () {
                    var slick = gallery.slick("getSlick");
                    var slideIndex = slick.$slides.filter(function () {
                        return String($(this).attr("data-image-src")).split("?")[0].split("/").pop() === String(variant.featured_image.src).split("?")[0].split("/").pop();
                    }).index();
                    if (slideIndex >= 0) gallery.slick("slickGoTo", slideIndex, true);
                };
                if (gallery.hasClass("slick-initialized")) {
                    selectVariantImage();
                } else {
                    gallery.off("init.variantImage").one("init.variantImage", selectVariantImage);
                }
            }

            // if(window.product_discount_amount !== undefined) {
            //   var saleTagPrice = Number(window.product_discount_amount);
            //   $(".product-form-new .price").text(((variant.price * (100 - saleTagPrice) / 100) / 100).toLocaleString('en-US', {style: 'currency',currency: 'USD'}));
            //   $(".product-form-new .price--on-sale").text((variant.price / 100).toLocaleString('en-US', {style: 'currency',currency: 'USD'})).removeClass("hide");

            // } else {

            $(".product-form-new .price").text((variant.price / 100).toLocaleString("en-US", { style: "currency", currency: "USD" }));
            if (variant.compare_at_price > variant.price) {
                $(".product-form-new .price--on-sale")
                    .text((variant.compare_at_price / 100).toLocaleString("en-US", { style: "currency", currency: "USD" }))
                    .removeClass("hide");
            } else {
                $(".price--on-sale").addClass("hide");
            }
            // }

          if (variant.available) {
                if (variant.inventory_policy == "continue" && variant.inventory_quantity <= 0) {
                    if (variant.incoming && variant.next_incoming_date) {
                        // PREORDER
                        $(".product-form-new").removeClass("available");
                        $(".product-form-new").addClass("preorder");
                        $(".product-form-new").removeClass("not-available");
                        $("#preorder-new__eta").text(variant.next_incoming_date);
                        $(".product-form__submit").text("PRE-ORDER");
                    } else {
                        // NOT AVAILABLE
                        $(".product-form-new").removeClass("available");
                        $(".product-form-new").removeClass("preorder");
                        $(".product-form-new").addClass("not-available");
                        $(".product-form__submit").text(window.variantStrings.soldOut);
                    }
                } else {
                    // AVAILABLE
                    $(".product-form-new").addClass("available");
                    $(".product-form-new").removeClass("preorder");
                    $(".product-form-new").removeClass("not-available");
                    $(".product-form__submit").html(
                        window.variantStrings.addToCart + " <span class='stick'></span> " + (variant.price / 100).toLocaleString("en-US", { style: "currency", currency: "USD" })
                    );
                }
            } else {
                // NOT AVAILABLE
                $(".product-form-new").removeClass("available");
                $(".product-form-new").removeClass("preorder");
                $(".product-form-new").addClass("not-available");
                $(".product-form__submit").text(window.variantStrings.soldOut);
            }
        }
    });

    firstLoad = false;
}

$(".product-form__submit").click(function (event) {
    event.preventDefault();
    console.log("add to cart");

    var product = null;
    var preorderProductFound = false;
    var preorderProductETA = null;

    $.each(productData.variants, function (i, variant) {
        if (variant.id === currentSelectedVariant) {
            if (variant.inventory_policy == "continue" && variant.inventory_quantity <= 0) {
                if (variant.incoming && variant.next_incoming_date) {
                    preorderProductETA = variant.next_incoming_date;
                    preorderProductFound = true;
                    return false;
                }
            }
        }
    });

    if (preorderProductFound) {
        product = {
            quantity: $("#Quantity-product-template-new").val(),
            id: currentSelectedVariant,
            properties: {
                "Pre-order": preorderProductETA,
            },
        };
    } else {
        product = {
            quantity: $("#Quantity-product-template-new").val(),
            id: currentSelectedVariant,
        };
    }

    $.ajax({
        url: "/cart/add.js",
        type: "POST",
        data: product,
        dataType: "json",
    })
        .done(function (data) {
            console.log("DONE");
            console.log(data);
            $(".site-header__cart-toggle").click();
        })
        .fail(function (data) {
            alert(data.message + "(" + data.status + "): " + data.description);
        });
});

$(document).on("click", function (e) {
    var container = $(".product-form__input--dropdown");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.addClass("dropdown-hide");
    }
});

document.addEventListener("DOMContentLoaded", function (event) {
    $(".form__label").on("click", function () {
        $(this).parent(".product-form__input--dropdown").removeClass("dropdown-hide");
    });

    checkVariants();

    trigerScrollReview();
});
function trigerScrollReview() {
    $(".rating-star [data-triger-scroll]").click(function () {
        $("html, body").animate(
            {
                scrollTop: $("[data-oke-reviews-nav-bar]").offset().top - 145,
            },
            800,
            function () {}
        );
    });
}

